import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'usage-cdn-component',
  templateUrl: './usage-cdn.component.html',
  styleUrls: ['./usage-cdn.component.scss'],
})
export class UsageCDNComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public gridCustomSettings: Array<any>;
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean;
  public isError: boolean;
  public currSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public httpService: HttpService,
    public gridService: GridService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.columnsSettings = [
      { key: 'day', label: 'DAY', filterType: 'INPUT', parseFunction: null, parseTooltipFunction: null },
      { key: 'type', label: 'TYPE', width: 200 },
      { key: 'volume', label: 'BANDWIDTH', width: 200, aggregated: true },
    ];
    this.isLoading = false;
    this.isError = false;
    this.subscriptions = [];
    this.startDate = new Date();
    this.endDate = new Date();
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.initialize();
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_DATA_UPDATED') {
          this.initialize();
        }
      })
    );
    this.sharedService.setPageTitle('CDN_USAGE');
  }

  initialize() {
    if (this.userService.getFeatureState('display_cdn')) {
      this.getCdnUsageFiles();
    } else {
      this.router.navigate(['/']);
    }
  }

  getCdnUsageFiles() {
    const params: any = {
      startDate: moment(new Date(this.startDate.setHours(0, 0, 0, 0))).format('ddd MMM DD YYYY HH:mm:ss'),
      endDate: moment(new Date(this.endDate.setHours(23, 59, 59, 0))).format('ddd MMM DD YYYY HH:mm:ss'),
    };
    if (this.currSubscription) {
      this.currSubscription.unsubscribe();
    }
    this.isLoading = true;
    this.currSubscription = this.httpService.post('cdn_files/getCdnUsageFiles', params).subscribe(
      (response: any) => {
        this.data = response.data;
        this.isLoading = false;
      },
      (error: any) => {
        // Display the error message
        this.isLoading = false;
        this.isError = true;
      }
    );
    this.subscriptions.push(this.currSubscription);
  }

  startDateChanged($event: any) {
    this.startDate = $event;
  }

  endDateChanged($event: any) {
    if ($event != null) {
      this.endDate = $event;
      this.getCdnUsageFiles();
    }
  }
}
